import { TextField } from "@mui/material";
import { CLAIM_STATUS_CONSTATNS, useClaimStatusData } from "./claimStatusData";
import searchIcon from "../../../../assets/images/searchIcon.png";

import "./index.scss";

const ClaimStatus = (props) => {
  const { setIsLoading } = props;

  const {
    claimStatusFormik,
    hasSearched,
    searchClaimResult,
    setSearchClaimResult,
    setHasSearched,
  } = useClaimStatusData({
    setIsLoading,
  });

  return (
    <div className="claim-status">
      <h6 className="claim-status__title">{CLAIM_STATUS_CONSTATNS.TITLE}</h6>

      <form
        onSubmit={claimStatusFormik.handleSubmit}
        className="claim-status__form"
      >
        <TextField
          name="imei"
          variant="outlined"
          value={claimStatusFormik.values.imei}
          label={CLAIM_STATUS_CONSTATNS.IMEI_LABEL}
          onChange={(e) => {
            claimStatusFormik.handleChange(e);
            if (e.target.value.trim() === "") {
              setSearchClaimResult(null);
              setHasSearched(false);
            }
          }}
          onBlur={claimStatusFormik.handleBlur}
          inputProps={{ maxLength: 15 }}
          error={
            claimStatusFormik.touched.imei &&
            Boolean(claimStatusFormik.errors.imei)
          }
          helperText={
            claimStatusFormik.touched.imei && claimStatusFormik.errors.imei
          }
          className="claim-status__input"
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#ccc",
              },
              "&:hover fieldset": {
                borderColor: "#999",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#1976d2",
                borderWidth: "2px",
              },
            },
            "& .MuiInputLabel-root": {
              "&.Mui-focused": {
                color: "#1976d2",
              },
            },
          }}
        />

        <button type="submit" className="claim-status__search-btn">
          {CLAIM_STATUS_CONSTATNS.SEARCH_CLAIMS_BUTTON}
        </button>
      </form>

      {searchClaimResult && (
        <div className="claim-status__result-card">
          <div className="claim-status__card-header">
            <h5 className="claim-status__card-title">
              {CLAIM_STATUS_CONSTATNS.CLAIM_STATUS}
            </h5>
          </div>

          <div className="claim-status__details-grid">
            <div>
              <div className="claim-status__detail-row">
                <dt className="claim-status__label">IMEI / Serial No.:</dt>
                <dd className="claim-status__value">
                  {searchClaimResult.serialOrIMEINumber || "-"}
                </dd>
              </div>
              <div className="claim-status__detail-row">
                <dt className="claim-status__label">
                  {CLAIM_STATUS_CONSTATNS.CUSTOMER_NAME}
                </dt>
                <dd className="claim-status__value">
                  {searchClaimResult.customerName || "-"}
                </dd>
              </div>
              <div className="claim-status__detail-row">
                <dt className="claim-status__label">
                  {CLAIM_STATUS_CONSTATNS.CLAIM_NUMBER}
                </dt>
                <dd className="claim-status__value">
                  {searchClaimResult.certificateNumber || "-"}
                </dd>
              </div>
              <div className="claim-status__detail-row">
                <dt className="claim-status__label">
                  {CLAIM_STATUS_CONSTATNS.MODEL}
                </dt>
                <dd className="claim-status__value">
                  {searchClaimResult.model || "-"}
                </dd>
              </div>
              <div className="claim-status__detail-row">
                <dt className="claim-status__label">
                  {CLAIM_STATUS_CONSTATNS.BRAND}
                </dt>
                <dd className="claim-status__value">
                  {searchClaimResult.brand || "-"}
                </dd>
              </div>
              <div className="claim-status__detail-row">
                <dt className="claim-status__label">
                  {CLAIM_STATUS_CONSTATNS.STATUS}
                </dt>
                <dd
                  className={`claim-status__value claim-status__value--status ${
                    searchClaimResult.caseStatus === "Approved"
                      ? "claim-status__value--status-approved"
                      : searchClaimResult.caseStatus === "Rejected"
                      ? "claim-status__value--status-rejected"
                      : "claim-status__value--status-pending"
                  }`}
                >
                  {searchClaimResult.caseStatus || "-"}
                </dd>
              </div>
              {searchClaimResult.cancelRejectReason && (
                <div className="claim-status__detail-row claim-status__reject-reason">
                  <dt className="claim-status__label">
                    {CLAIM_STATUS_CONSTATNS.REJECT_REASON}
                  </dt>
                  <dd className="claim-status__value">
                    {searchClaimResult.cancelRejectReason}
                  </dd>
                </div>
              )}
            </div>

            <div>
              <div className="claim-status__detail-row">
                <dt className="claim-status__label">City:</dt>
                <dd className="claim-status__value">
                  {searchClaimResult.city || "-"}
                </dd>
              </div>
              <div className="claim-status__detail-row">
                <dt className="claim-status__label">State:</dt>
                <dd className="claim-status__value">
                  {searchClaimResult.state || "-"}
                </dd>
              </div>
              <div className="claim-status__detail-row">
                <dt className="claim-status__label">
                  {CLAIM_STATUS_CONSTATNS.CONCERNED_PERSON_NAME}
                </dt>
                <dd className="claim-status__value">
                  {searchClaimResult.concernedPersonName || "-"}
                </dd>
              </div>
              <div className="claim-status__detail-row">
                <dt className="claim-status__label">
                  {CLAIM_STATUS_CONSTATNS.DEALER}
                </dt>
                <dd className="claim-status__value">
                  {searchClaimResult.dealer || "-"}
                </dd>
              </div>
            </div>
          </div>
        </div>
      )}

      {(!searchClaimResult ||
        !hasSearched ||
        Object.keys(searchClaimResult).length === 0) && (
        <div className="claim-status__empty-state">
          <img
            src={
              hasSearched
                ? "https://cdn-icons-png.flaticon.com/512/2748/2748558.png"
                : searchIcon
            }
            alt="Not found"
            className="claim-status__empty-icon"
          />

          <h6 className="claim-status__empty-title">
            {hasSearched
              ? CLAIM_STATUS_CONSTATNS.CLAIM_NOT_FOUND
              : CLAIM_STATUS_CONSTATNS.SEARCH_CLAIMS_BUTTON}
          </h6>

          <p className="claim-status__empty-desc">
            {hasSearched
              ? CLAIM_STATUS_CONSTATNS.CLAIM_NOT_FOUND_DESC
              : CLAIM_STATUS_CONSTATNS.ENTER_VALID_IMEI_DESC}
          </p>
        </div>
      )}
    </div>
  );
};

export default ClaimStatus;
